module.exports = __webpack_public_path__ + "static/img/4.5dc0072.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/taijia/4.png
// module id = FQ1i
// module chunks = 1